import { FC } from 'react';
import { useTranslation } from 'react-i18next';
import useFetchCurrentUser from '@components/features/currentUser/hooks/useFetchCurrentUser';
import useFetchVersion from '@hooks/useFetchVersion';

const StatusBar: FC = () => {
    const { t } = useTranslation();
    const { data: versionData } = useFetchVersion();
    const { data: user } = useFetchCurrentUser();

    if (!versionData || !user || !versionData?.otapState || versionData?.otapState === 'P') {
        return null;
    }

    const tenant = user?.tenantId || 'UNKNOWN';

    const msg = {
        O: t('message.O', { ns: 'statusBar', tenant }),
        T: t('message.T', { ns: 'statusBar', tenant }),
        A: t('message.A', { ns: 'statusBar', tenant }),
    }[versionData.otapState];

    return <div className="statusBar">{msg}</div>;
};

export default StatusBar;
